// ======================================================================
// File Name       : container
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const CONTAINER_RECEIVE_COURSE_STRUCTURE = 'CONTAINER_RECEIVE_COURSE_STRUCTURE';
export const CONTAINER_INIT_DATA_FOR_EDIT_STRUCTURE = 'CONTAINER_INIT_DATA_FOR_EDIT_STRUCTURE';
export const CONTAINER_UPDATE_DISPLAY_ORDER = 'CONTAINER_UPDATE_DISPLAY_ORDER';
export const CONTAINER_REINIT_CONTAINER_TREE = 'CONTAINER_REINIT_CONTAINER_TREE';
export const CONTAINER_DESTROY_CONTAINER_TREE = 'CONTAINER_DESTROY_CONTAINER_TREE';
export const CONTAINER_INIT_CONTAINER_TREE = 'CONTAINER_INIT_CONTAINER_TREE';
// sprint_20230522_tma START
export const CONTAINER_RECEIVE_COURSE_STRUCTURE_ITEM_TREE = 'CONTAINER_RECEIVE_COURSE_STRUCTURE_ITEM_TREE';
export const CONTAINER_SELECTED_ITEM_ON_DIALOG = 'CONTAINER_SELECTED_ITEM_ON_DIALOG';
export const CONTAINER_DEL_SELECTED_ITEM_ON_DIALOG = 'CONTAINER_DEL_SELECTED_ITEM_ON_DIALOG';
export const REMOVED_DATA_WITH_SELECTED_ITEM_LIST ='REMOVED_DATA_WITH_SELECTED_ITEM_LIST';
export const CONTAINER_INIT_DATA_FOR_ITEM_TREE_DIALOG = 'CONTAINER_INIT_DATA_FOR_ITEM_TREE_DIALOG';
// sprint_20230522_tma END
